import { render, staticRenderFns } from "./freightDetail.vue?vue&type=template&id=771f5a18&scoped=true"
import script from "./freightDetail.vue?vue&type=script&lang=js"
export * from "./freightDetail.vue?vue&type=script&lang=js"
import style0 from "./freightDetail.vue?vue&type=style&index=0&id=771f5a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f5a18",
  null
  
)

export default component.exports